import axios, { AxiosInstance } from 'axios'

type CreateApiClientOptions = {
  baseURL: string
  token?: string
}

export const createApiClient = ({ baseURL }: CreateApiClientOptions): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    headers: {
      accept: 'application/json',
    },
  })

  // Request interceptor
  instance.interceptors.request.use((config) => {
    const userObject = localStorage.getItem('__TG')

    if (userObject !== null && userObject !== 'null' && userObject) {
      const token = userObject && JSON.parse(userObject).token

      // config.headers['X-Access-Token'] = token

      config.headers.Authorization = `Bearer ${token}`
    }

    config.headers['Access-Control-Allow-Origin'] = '*'
    return config
  })

  const redirectToLogin = () => {
    localStorage.removeItem('__TG')
    window.location.href = '/login'
  }

  instance.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      const status = error?.response?.status
      const errorMessage = error?.response?.data?.error
      const fallbackMessage = error?.response?.data?.message
      const authMessage = `${errorMessage || fallbackMessage || ''}`.toLowerCase()

      const shouldLogout =
        status === 401 ||
        authMessage === 'unauthorized' ||
        authMessage === 'access token expired' ||
        authMessage.includes('token expired') ||
        authMessage.includes('unauthorized')

      if (shouldLogout) {
        redirectToLogin()
      }

      return Promise.reject(error)
    },
  )

  return instance
}

export const AuthXInterceptor = createApiClient({
  baseURL: process.env.REACT_APP_BX_BASE_URL || '',
})
